import type { Util } from '../../../types/util';

const baseContainer: Util.VariantCSSKeys<ContainerVariantsType> = {
  small: {
    top: 0,
    left: '3px',
  },
  medium: {
    top: 0,
    left: '2px',
  },
  large: {
    top: 0,
    left: '5px',
  },
};

const container: Util.VariantKeyModes<ContainerVariantsType> = {
  products: {
    chart: baseContainer,
    chartblog: baseContainer,
    co: baseContainer,
    edu: baseContainer,
    scale: baseContainer,
    spark: baseContainer,
  },
};

export type ContainerVariantsType = 'small' | 'medium' | 'large';
export const containerVariants = Object.keys(baseContainer) as ContainerVariantsType[];

export default container;
